// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  	production: true,
	//   API: 'https://avaap.fr/api/',
	//   MEDIA : 'https://avaap.fr/'
	// API : 'https://atid.dev.jlconsulting.fr/api/',
	// MEDIA : 'https://atid.dev.jlconsulting.fr/'

	API : 'https://atid.v2.dev.jlconsulting.fr/api/',
	MEDIA : 'https://atid.v2.dev.jlconsulting.fr/'
};